import { FormMode } from '../../controls/common/form-mode';
import { BoxFormContext } from './box-form-context';

export class BoxDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.boxContext.mode = value;
    }

    public editedBoxId: string = null;

    public boxContext: BoxFormContext = new BoxFormContext();
}
